import styled from "styled-components"

// Timeline status colors (matching ChevronTimeline)
const colors = {
    pending: {
        bg: "#ffffff",
        border: "#dee2e6",
        text: "#767676",
    },
    completed: {
        bg: "#f5faff",
        border: "#cde4fd",
        text: "#1f2937",
    },
    current: {
        bg: "#417dd1",
        border: "#417dd1",
        text: "#ffffff",
    },
    vetoed: {
        bg: "#f46a6c",
        border: "#f46a6c",
        text: "#ffffff",
    },
    "final-success": {
        bg: "#6ccf7d",
        border: "#6ccf7d",
        text: "#ffffff",
    },
}

export const Container = styled.div`
    font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    width: 100%;
    margin: 10px 0;
`

export const Steps = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
`

export const Step = styled.div`
    display: inline-flex;
    align-items: center;
    padding: 6px 12px;
    border-radius: 4px;
    border: 1px solid;
    font-size: 12px;
    font-weight: 500;
    white-space: nowrap;
    transition: all 0.2s ease;
    
    background: ${props => colors[props.status]?.bg || colors.pending.bg};
    border-color: ${props => colors[props.status]?.border || colors.pending.border};
    color: ${props => colors[props.status]?.text || colors.pending.text};
    font-weight: ${props => (props.status === "current" || props.status === "vetoed" || props.status === "final-success") ? 600 : 500};

    @media (max-width: 1300px) {
        font-size: 11px;
        padding: 5px 10px;
    }

    @media (max-width: 1130px) {
        font-size: 10px;
        padding: 4px 8px;
    }

    @media (max-width: 768px) {
        font-size: 9px;
        padding: 3px 6px;
    }
`

export const Label = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
`

export const Arrow = styled.div`
    color: #9ca3af;
    font-size: 16px;
    font-weight: bold;
    flex-shrink: 0;

    @media (max-width: 1300px) {
        font-size: 14px;
    }

    @media (max-width: 1130px) {
        font-size: 12px;
    }

    @media (max-width: 768px) {
        font-size: 10px;
    }
`

export const Icon = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 14px;
    color: inherit;
`

